"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdvancedToggle = void 0;
var _jsxRuntime = require("react/jsx-runtime");
const AdvancedToggle = ({
  checked,
  onChange
}) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
    className: "form-check form-switch toggle-row",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      className: "form-check-input",
      type: "checkbox",
      role: "switch",
      checked: checked,
      onChange: event => onChange(event.target.checked)
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "form-check-label",
      children: "Advanced mode"
    })]
  });
};
exports.AdvancedToggle = AdvancedToggle;